import { render, staticRenderFns } from "./foooter.vue?vue&type=template&id=bf5220ec&"
import script from "./foooter.vue?vue&type=script&lang=js&"
export * from "./foooter.vue?vue&type=script&lang=js&"
import style0 from "./foooter.vue?vue&type=style&index=0&id=bf5220ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports